import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'

import styles from './styles.css'

export default class FormElement extends PureComponent {
  static propTypes = {
    label: PropTypes.string.isRequired,
    labelStyle: PropTypes.object,
    elementContainerStyle: PropTypes.object,
  }

  static defaultProps = {
    labelStyle: {},
    elementContainerStyle: {},
  }

  render() {
    const { children, label, labelStyle, elementContainerStyle } = this.props

    return (
      <div className={styles.inputWrapper}>
        <span className={styles.inputLabel} style={labelStyle}>
          {label}
        </span>
        <div className={styles.inputElement} style={elementContainerStyle}>
          {children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/formElement/index.js